import type { CabinUpgradePricingGetParams } from '~/services/CharterService';

export const cabinUpgradePricingQueryKeys = {
  all: ['cabinUpgradePricing'] as const,
  lists: () => [...cabinUpgradePricingQueryKeys.all, 'list'] as const,
  list: (params: CabinUpgradePricingGetParams) => [...cabinUpgradePricingQueryKeys.lists(), params] as const,
};
